import { getSession, setSession, removeSession } from "@/utils/auth";
import { resetRouter } from "@/router";
//
const state = {
  token: getSession('token'),
  name: getSession('name'),
  shopCode: getSession('shopCode'),
  roles: [],
  stores: getSession('stores'),
  plat: getSession('plat'),
  fromWhereToLabelPage: '',
  detailsDataParams: {}
}
const mutations = {
  SET_TOKEN: (state, data) => {
    state.token = data
  },
  SET_NAME: (state, data) => {
    state.name = data
  },
  SET_ROLES: (state, data) => {
    state.roles = data
  },
  SET_STORES: (state, data) => {
    state.stores = data
  },
  CHANGE_SHOPCODE: (state, data) => {
    state.shopCode = data
  },
  SET_PLAT: (state, data) => {
    state.plat = data
  },
  SET_FROMWHERETOLABELPAGE: (state, data) => {
    state.fromWhereToLabelPage = data
  },
  SET_DETAILSDATAPARAMS: (state, data) => {
    state.detailsDataParams = data
  }
}
const actions = { 


  login({ dispatch, commit, state }, data) {
    return new Promise((resolve, reject) => {

      api.login(data).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data
          const {sysShops = [], jwtToken, realName, userName, userId} = data
          setSession('token', jwtToken)
          setSession('realName', realName)
          setSession('name', userName)
          setSession('userId', userId)
          // setSession('stores', JSON.stringify(data.sysShops))
          if (sysShops.length) setSession('shopCode', sysShops[0].sellerId)

          commit('SET_TOKEN', jwtToken)
          commit('SET_NAME', userName)
          dispatch('getUserPlat')
          // commit('SET_STORES', data.sysShops)
          // commit('CHANGE_SHOPCODE', data.sysShops[0].sellerId)

          resolve()
        } else {
          reject()
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },

  getUserPlat({ commit, state }) {
    return new Promise((resolve, reject) => {
      api.getUserPlatList().then(res => {

        if (res.data.code === 200) {
          let data = res.data.data

          let plat = getSession('plat')
          if (plat) {
            let status = data.find((item) => item.plat == plat)

            if (!Boolean(status)) {
              setSession('plat', res.data.data[0].plat)
            }
          } else {
            setSession('plat', res.data.data[0].plat)
          }


        }

        commit('SET_PLAT', res.data.data)
        resolve(res.data)
      })
    })

  },


  getMenu({ dispatch, commit, state }) {
    return new Promise((resolve, reject) => {
      api.getMenuList({ plat: getSession('plat') }).then((res) => {
        // console.log(res.data,'res------++++')
        if (res.data.code == 200) {
          let data = res.data.data
          let roles = data && data
          // 获取菜单
          commit('SET_ROLES', roles)

          resolve(roles)
        } else {
          dispatch('resetRoles')
          reject()
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getShop({ dispatch, commit, state }, params) {
    
    return new Promise((resolve, reject) => {
      api.getShopList({ plat: getSession('plat') }).then((res) => {
        if (res.data.code == 200) {

          let data = res.data.data
          let status = data.find((item) => item.sellerId === getSession('shopCode'))
          console.log(params, status)
          if (params === 'cut' || !Boolean(status)) {
            setSession('stores', JSON.stringify(data))
            setSession('shopCode', data[0].sellerId)
            setSession('shopName', data[0].shopName)
            commit('CHANGE_SHOPCODE', data[0].sellerId)
          }

          commit('SET_STORES', data)
          //
          resolve(data)
        } else {
          // dispatch('resetStores')
          reject()
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  changeShopCode({ commit }, data) {
    commit('CHANGE_SHOPCODE', data)
  },
  resetRoles({ commit }) {
    commit('SET_ROLES', '')
  },
  logout({ dispatch, commit, state }) {
    return new Promise((resolve, reject) => {

      api.logout().then((res) => {
        if (res.data.code == 200) {
          dispatch('resetSession')
          resetRouter()
          resolve()
        } else {
          reject()
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  resetSession({ dispatch, commit }) {
    return new Promise(resolve => {
      removeSession('name')
      removeSession('token')
      dispatch('resetRoles')
      resolve()
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js